// extracted by mini-css-extract-plugin
export default {"para":"Chapter_para__Q2feR","videos":"Chapter_videos__r0Y+C"};